export enum AuthMethods {
   wallet = 'wallet',
   email = 'email',
}
